import { Injectable, Inject } from '@angular/core';
import { HttpInterceptorService } from '../../../core/services/http-interceptor.service';
import { CoreActionCreatorService } from '../../../core/services/core-action-creator.service';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AnnotationResult } from '../components/editable-annotation/editable-annotations.component';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';

@Injectable()
export class EditableAnnotationService {
  constructor(
    private _http: HttpInterceptorService,
    private _coreAc: CoreActionCreatorService,
    private notificationMessageService: NotificationMessageService
  ) { }

  updateAnnotations(url: string, annotation: AnnotationResult, backgroundSpinner: boolean = false): Observable<any> {
    return this._http.put(url, annotation, backgroundSpinner).pipe(
      map(response => response.json()),
      map(response => {
        this.notificationMessageService.success('Annotation successfully updated');
        return response;
      }),
      catchError(err => {
        this.notificationMessageService.error('Unable to update annotation');
        return Observable.throw(err.message);
      })
    );
  }

  //Some of the annotations are directly propagated within the aberration resource and so should only be updated there
  updateAberration(url: string, aberration: any, backgroundSpinner: boolean = false): Observable<any> {
    return this._http.put(url, aberration, backgroundSpinner).pipe(
      map(response => response.json()),
      map(response => {
        this.notificationMessageService.success('Aberration successfully updated');
        return response;
      }),
      catchError(err => {
        this.notificationMessageService.error('Unable to update aberration');
        return Observable.throw(err.message);
      })
    );
  }
}
